// Slider logotypow partnerow (Splide) pod aktualnosciami.
// Strzalki i bullety wlasne (jak w hero), autoplay zatrzymuje sie na stale
// po pierwszej interakcji uzytkownika (strzalka, bullet, przeciagniecie).

import Splide from "@splidejs/splide";

export function initPartnersSlider() {
  const root = document.querySelector("[data-partners-slider]");
  if (!root) return;

  if (!("IntersectionObserver" in window)) {
    mountPartnersSlider(root);
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      obs.disconnect();
      mountPartnersSlider(root);
    },
    { rootMargin: "600px 0px" }
  );

  observer.observe(root);
}

function mountPartnersSlider(root) {
  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  const splide = new Splide(root, {
    type: "loop",
    perPage: 6,
    perMove: 6,
    gap: "1.6rem",
    speed: 700,
    arrows: false,
    pagination: false,
    autoplay: !prefersReduced,
    interval: 4000,
    pauseOnHover: true,
    pauseOnFocus: true,
    keyboard: "focused",
    breakpoints: {
      1100: { perPage: 4, perMove: 4 },
      900: { perPage: 3, perMove: 3 },
      600: { perPage: 2, perMove: 2 },
    },
  });

  const section = root.closest(".partners");
  const dotsWrap = section?.querySelector("[data-partners-dots]");
  const prev = section?.querySelector("[data-partners-prev]");
  const next = section?.querySelector("[data-partners-next]");

  const stopAutoplay = () => splide.Components.Autoplay?.pause();

  const pageOf = (index) => Math.floor(index / splide.options.perPage);

  const setActiveDot = (index) => {
    if (!dotsWrap) return;
    const page = pageOf(index);
    Array.from(dotsWrap.children).forEach((dot, i) => {
      const active = i === page;
      dot.classList.toggle("is-active", active);
      if (active) dot.setAttribute("aria-current", "true");
      else dot.removeAttribute("aria-current");
    });
  };

  const buildDots = () => {
    if (!dotsWrap) return;
    const pages = Math.ceil(splide.length / splide.options.perPage);
    dotsWrap.innerHTML = "";

    for (let i = 0; i < pages; i++) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "partners__dot";
      dot.setAttribute("aria-label", `Partnerzy - strona ${i + 1}`);
      dot.addEventListener("click", () => {
        stopAutoplay();
        splide.go(i * splide.options.perPage);
      });
      dotsWrap.append(dot);
    }

    setActiveDot(splide.index);
  };

  splide.on("move", (newIndex) => setActiveDot(newIndex));
  splide.on("mounted updated", buildDots);
  splide.on("drag", stopAutoplay);

  prev?.addEventListener("click", () => {
    stopAutoplay();
    splide.go("<");
  });

  next?.addEventListener("click", () => {
    stopAutoplay();
    splide.go(">");
  });

  splide.mount();
}
